@use 'kci-design-lib/styles/variables.scss' as *;
.popover {
  position: relative;
  font-family: $font-family;
  .trigger-element {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    & > div {
      display: inline-flex;
    }
    img {
      filter: var(--filter-icon-neutral);
    }
    &.hide-pointer {
      img {
        filter: var(--filter-icon-neutral);
      }
    }
    &:hover {
      img {
        filter: var(--filter-icon-accent);
      }
    }
    .active-trigger {
      img {
        filter: var(--filter-icon-accent);
      }
    }
    &:not(.hide-pointer) {
      [data-pc-name='button'] {
        &:has(img:only-child) {
          height: 24px;
          width: 24px;
          border: none;
        }
      }
      img {
        height: 24px;
        width: 24px;
        border: none;
      }
    }
  }
}
.overlay-panel {
  font-family: $font-family;
  border-radius: 4px;
  box-shadow: $elevation-level3;
  opacity: 0;
  visibility: hidden;
  background-color: var(--surface-elevated);
  &:not(.hide-pointer) {
    max-width: 250px;
    &[data-pc-name='overlaypanel'] {
      &[data-pc-section='root'] {
        border: none !important; 
      }
      [alt='Close'] {
        width: 12px;
        height: 12px;
      }
    }
  }
  &.visible {
    opacity: 1;
    visibility: visible;
  }
  &.hide-pointer {
    min-width: 148px;
    &::before,
    &::after {
      display: none;
    }
    box-shadow: $elevation-level4;
    border: 1px solid var(--divider-border);
    border-radius: 8px;
    .popover-content {
      padding-right: 0;
      & > div {
        display: flex;
        flex-direction: column;
        gap: 20px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.2px;
        & > div {
          display: flex;
          gap: 8px;
          align-items: center;
        }
      }
    }
    [data-pc-section='closebutton'] {
      display: none;
    }
    [data-pc-section='content'] {
      padding: 14px 16px 18px;
    }
    &.top-left,
    &.top-center,
    &.top-right {
      margin: 8px 0 0 0;
    }
    &.bottom-left,
    &.bottom-center,
    &.bottom-right {
      margin: -8px 0 0 0;
    }
    &.left {
      margin: 0 0 0 8px;
    }
    &.right {
      margin: 0 8px 0 0;
    }
  }
  &.icon {
    &.top-left {
      margin: -2px 0 0 -8px;
    }
    &.top-center {
      margin: -2px 0 0;
    }
    &.top-right {
      margin: -2px 0 0 8px;
    }
    &.bottom-left {
      margin: 1px 0 0 -8px;
    }
    &.bottom-center {
      margin: 1px 0 0;
    }
    &.bottom-right {
      margin: 1px 0 0 8px;
    }
    &.left {
      margin: 0 0 0 -2px;
    }
    &.right {
      margin: 0 0 0 1px;
    }
  }
  &.pointer {
    &::before,
    &::after {
      display: block;
    }
  }
  [data-pc-section='content'] {
    padding: 12px;
    max-height: 50vh;
    overflow: auto;
  }
  .popover-header {
    &:not(:empty) {
      padding-bottom: 4px;
      padding-right: 18px;
      font-weight: 700;
      font-size: 16px;
      line-height: 160%;
      letter-spacing: 0px;
      color: $text;
      color: var(--text-emphasis);
    }
  }
  .popover-content {
    padding-right: 18px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: var(--card-content-color);
    button {
      &:not(:only-child) {
        height: 20px;
        width: 20px;
        border: none;
        padding: 0;
      }
      img {
        height: 20px;
        width: 20px;
        border: none;
      }
    }
  }
  .popover-actions {
    &:not(:empty) {
      padding-top: 8px;
      display: flex;
      gap: 8px;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0.2px;
      color: var(--card-content-color);
      align-self: center;
      & > div {
        &:has(:nth-child(2)) {
          display: flex;
          gap: 8px;
        }
      }
    }
  }
  &.hide-close {
    .popover-header,
    .popover-content {
      padding-right: 0;
    }
  }
  [data-pc-section='closebutton'] {
    top: 12px;
    right: 8px;
    width: 20px;
    height: 20px;
    position: absolute;
    border: none;
    background: var(--neutral-light-5);
    &:has(.hide-close-icon) {
      display: none;
    }
    &[aria-label='Close'] {
      width: 20px !important; 
      height: 20px !important; 
    }
  }
  [data-button-type='primary'] {
    padding: 6px 12px;
  }
  &::before {
    box-sizing: border-box;
    border: solid transparent;
    border-color: transparent;
    border-bottom-color: var(--surface-elevated);
    border-width: 6px;
    margin-left: -5px;
  }
  &::after {
    box-sizing: border-box;
    border-width: 6px;
    margin-left: -5px;
    border-bottom-color: var(--surface-elevated);
  }
  &[class*='top'] {
    &::before,
    &::after {
      bottom: -12px;
      transform: rotate(180deg);
    }
  }
  &.top-left {
    margin: -4px 0 0 -10px;
    &::before,
    &::after {
      left: 21px;
    }
  }
  &.top-center {
    margin: -4px 0 0 4px;
    &::before,
    &::after {
      left: 48%;
    }
  }
  &.top-right {
    margin: -4px 0 0 10px;
    &::before,
    &::after {
      left: calc(100% - 23px);
    }
  }
  &[class*='bottom'] {
    &::before,
    &::after {
      transform: none;
    }
  }
  &.bottom-left {
    margin: 4px 0 0 -10px;
    &::before,
    &::after {
      left: 21px;
    }
  }
  &.bottom-center {
    margin: 4px 0 0 4px;
    &::before,
    &::after {
      left: 48%;
    }
  }
  &.bottom-right {
    margin: 4px 0 0 10px;
    &::before,
    &::after {
      left: calc(100% - 23px);
    }
  }
  &.left {
    margin: 1px 0 0 -4px;
    &::before,
    &::after {
      transform: rotate(90deg);
      top: 45%;
      left: 255px;
    }
  }
  &.right {
    margin: 1px 0 0 4px;
    &::before,
    &::after {
      transform: rotate(-90deg);
      top: 45%;
      left: -7px;
    }
  }
  div {
    &:has(:not([data-pc-section='closebutton'])) {
      img {
        filter: var(--filter-icon-neutral);
        &:hover {
          filter: var(--filter-icon-accent);
        }
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .overlay-panel {
    &:not(.hide-pointer) {
      width: 250px;
    }
    &.hide-pointer {
      max-width: 170px;
    }
  }
}
.overlay-panel {
  &.hide-pointer {
    .popover-content {
      > div > div {
        cursor: pointer;
        &:hover {
          > div:last-child {
            color: #00338d;
          }
          img {
            filter: brightness(0) saturate(100%) invert(16%) sepia(72%) saturate(2478%)
              hue-rotate(209deg) brightness(91%) contrast(109%) !important;
          }
        }
      }
    }
  }
}
html[data-theme='dark'] {
  .popover {
    .trigger-element {
      &:hover,
      .active-trigger {
        img {
          filter: brightness(0) saturate(100%) invert(89%) sepia(54%) saturate(2595%)
            hue-rotate(169deg) brightness(97%) contrast(109%);
        }
      }
    }
  }
  .overlay-panel {
    &.hide-pointer {
      .popover-content {
        > div > div {
          cursor: pointer;
          > div:last-child {
            color: #b2b2b2;
          }
          img {
            filter: brightness(0) saturate(100%) invert(86%) sepia(93%) saturate(5889%)
              hue-rotate(176deg) brightness(111%) contrast(101%) !important;
          }
          &:hover {
            > div:last-child {
              color: #def7ff;
            }
            img {
              filter: brightness(0) saturate(100%) invert(86%) sepia(93%) saturate(5889%)
                hue-rotate(176deg) brightness(111%) contrast(101%) !important;
            }
          }
        }
      }
    }
  }
}
